import { getBrandStatusLabel } from '../../../../types/brand.types';

import { SelectAutocomplete } from '../../../../components';
import './BrandsTable.css';
import { BrandsTableProps } from './BrandsTable.types';

export function BrandsTable({
  brands,
  changedRows,
  statusOptions,
  canCreate,
  onCellValueChange,
  bodyRef
}: BrandsTableProps): JSX.Element {
  return (
    <div className="brands-table-wrapper" ref={bodyRef}>
      <table className="brands-results-table">
        <tbody>
          {brands.map(brand => (
            <tr key={brand.id} className={`brands-table-row ${changedRows.includes(brand.id) ? 'changed' : ''}`}>
              <td className="brands-table-cell brands-col-id">{brand.id}</td>
              <td className="brands-table-cell brands-col-name">
                <span className={`brands-brand-badge ${brand.name === 'ОККО' ? 'okko' : 'other'}`}>{brand.name}</span>
              </td>
              <td className="brands-table-cell brands-col-order">{brand.order_number}</td>
              <td className="brands-table-cell brands-col-azk-count">{brand.azk_count}</td>
              <td className="brands-table-cell brands-col-active-azk">{brand.active_azk_count}</td>
              <td className="brands-table-cell brands-col-status">
                {canCreate ? (
                  <SelectAutocomplete
                    options={statusOptions.map(option => option.label)}
                    value={getBrandStatusLabel(brand.status)}
                    onChange={value => {
                      const selectedOption = statusOptions.find(option => option.label === value);
                      if (selectedOption) {
                        onCellValueChange(brand.id, 'status', selectedOption.value);
                      }
                    }}
                    selectOnly
                    className="brands-status-selector"
                  />
                ) : (
                  <span>{getBrandStatusLabel(brand.status)}</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
